import { render, staticRenderFns } from "./select-room-type.vue?vue&type=template&id=60b58024"
import script from "./select-room-type.vue?vue&type=script&lang=ts"
export * from "./select-room-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports